import { useFeatureFlag } from "providers/LaunchDarkly";
import { HalloweenGhost } from "./Ghost";
import { useHalloweenFavicon } from "./useHalloweenFavicon";

const HalloweenFavicon = () => {
  useHalloweenFavicon();
  return null;
};

/** App-wide Halloween effects (pumpkin tab icon and the "boo" ghost), mounted only while the flag is on. */
export const HalloweenEffects = () => {
  const halloween = useFeatureFlag("halloween-easter-eggs");
  if (!halloween) return null;
  return (
    <>
      <HalloweenFavicon />
      <HalloweenGhost />
    </>
  );
};
